import { InputAdornment } from '@material-ui/core'

export const editFields = (values, handleChange, getIcon) => {
  const isPrimaryPhone = values.realKey === 'telefono1'
  return [
    {
      label: 'Concepto',
      name: 'realKey',
      sm: 12,
      xs: 12,
      class: 'textfield',
      value: values.realKey.charAt(0).toUpperCase() + values.realKey.slice(1).toLowerCase(),
      inputProps: {
        startAdornment: <InputAdornment position="start">{getIcon(values.realKey)}</InputAdornment>,
      },
      disabled: true,
    },
    {
      label: 'Descripción',
      name: 'descripcion',
      sm: 12,
      xs: 12,
      class: 'textfield',
      value: values.descripcion,
      disabled: isPrimaryPhone,
      onChange: (e) => handleChange('descripcion', e.target.value),
    },
  ]
}
